const CommissionSalary = {
  AddCommission: "CommissionSalary.AddCommission",
  Commission: "CommissionSalary.Commission",
  EmployeesSalaryDeviations: "CommissionSalary.EmployeesSalaryDeviations",
  }
export default CommissionSalary;